module.exports = __webpack_public_path__ + "img/58ne.ca302405.svg";